<template>
  <div class="row">
    <div class="col-md-12">
      <base-crud
          :ref="'eventTypesCrud'"
          :crudName="$t('Event types')"
          :newText="$t('Add')+ '  '+$t('New')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
      >
      </base-crud>
    </div>
  </div>
</template>


<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "eventTypesTable",
      showMessageImport: false,
      eventTypesCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "code",
        "criticality_type_id",
        "description",
        "actions",
      ],
      tableData: ["id", "name"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "code", "criticality_type_id", "description"],
        sortable: ["id", "name", "code", "criticality_type_id", "description"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          name: this.$t('Name'),
          code: this.$t('code'),
          criticality_type_id: this.$t('Criticality type'),
          description: this.$t('description'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {},
        templates: {
          criticality_type_id: function (h, row, index) {
            return row.criticality_type?.name ?? ''

          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["criticalityType"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "eventtypes",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        name: this.$t('Name'),
        code: this.$t('code'),
        criticality_type_id: this.$t('Criticality type'),
        description: this.$t('description'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }

    }

  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        code: "code",
        criticality_type_id: "criticalityType[name]",
        description: "description",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

  },
};
</script>


<style scoped>
.VuePagination {
  text-align: center;
}
</style>
